var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"event-rms"},[_c('content-header',{attrs:{"path":"Documentos"}}),_vm._v(" "),_c('item-documents',{staticClass:"col-8",attrs:{"items":_vm.items,"event-date":_vm.eventDetails.date && _vm.eventDetails.date.event}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42cddf1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/event-rms/EventRms.vue
// module id = null
// module chunks = 